
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class ScanlineProcessorEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const spacing = (10 + layerIndex * 5) / (config.parallaxPatternDensity || 1.0);
        const { y1, y2 } = this.getGridBounds(pc, spacing );
        const scale = config.parallaxScale || 1.0;
        const curTime = time * config.parallaxSpeed;

        ctx.fillStyle = pc.color;

        const draw = () => {
             // Flickering background
             if (Math.sin(curTime * 10) > 0.8) {
                 ctx.save();
                 ctx.globalAlpha *= 0.05;
                 ctx.fillRect(-width * 2, -height * 2, width * 4, height * 4);
                 ctx.restore();
             }

            for (let y = y1; y <= y2; y += spacing) {
                ctx.save();
                ctx.globalAlpha *= 0.1 / layerIndex;
                ctx.fillRect(-width * 2, y, width * 4, 2 * scale);
                ctx.restore();
            }
            
            // Traveling bar
            const barY = ((curTime * 100) % (height * 3)) - height * 1.5;
            ctx.save();
            ctx.globalAlpha *= 0.2;
            ctx.fillRect(-width * 2, barY, width * 4, 20 * scale);
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
